import React, { useState, useEffect } from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@material-ui/core'

const EditSeasonTeamModal = ({ open, team, onClose, onConfirm, isLoading }) => {
  const [name, setName] = useState('')

  useEffect(() => {
    if (open && team) {
      setName(team.teamName || '')
    }
  }, [open, team])

  const handleConfirm = () => {
    if (name.trim()) {
      onConfirm(name.trim())
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>Edit Season Team Name</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label='Name'
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && name.trim() && handleConfirm()}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          color='primary'
          variant='contained'
          disabled={!name.trim() || isLoading}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditSeasonTeamModal
